import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { DataObjectUrl } from './DataObjectUrl';
import { DataObjectVersionSchema } from '../schema/DataObjectVersionSchema';
import { ISODate } from '../../common/utils';

export const getDataObjectVersions = ({
  id,
  valueDate,
}: {
  id: number;
  valueDate?: ISODate;
}) =>
  apiClient
    .get(
      expand(DataObjectUrl.DATA_OBJECT_VERSIONS, {
        id,
        valueDate,
      }),
    )
    .then((response) => DataObjectVersionSchema.array().parse(response.data));

export const useDataObjectVersionsQuery = createApiQueryHook(
  ['description-data-object-versions'],
  getDataObjectVersions,
);
